import { wait } from "next/dist/lib/wait"
import { INTERSHOP_APITOKEN_COOKIE_NAME } from "@/constants"
import { serialize } from "cookie"

export async function getIntershopAuthenticatedApiToken(data: any) {
  const apiTokenCookieData = {
    apiToken: data.access_token,
    type: "user",
    isAnonymous: false,
    creator: "pwa",
  }
  const apiTokeCookie = JSON.stringify(apiTokenCookieData)

  //console.dir(apiTokeCookie)

  return serialize(INTERSHOP_APITOKEN_COOKIE_NAME, apiTokeCookie, {
    httpOnly: false,
    secure: true,
    /*Careful! Cookies should be "SameSite:strict to be secure!"*/
    // @ts-ignore
    sameSite: "none",
    maxAge: 3600,
    path: "/",
  })
}

export async function login(username: string, password: string) {
  const response = await fetchWithRetry(
    process.env.NEXT_PUBLIC_BASE_PATH ? process.env.NEXT_PUBLIC_BASE_PATH + "/api/auth/islogin" : "/api/auth/islogin",
    {
      method: "POST",
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    }
  )
  return response.status === 200
}

async function fetchWithRetry(input, init, retries = 3, retryDelay = 1000) {
  const response = await fetch(input, init)
  if (response.status === 500) {
    if (retries > 0) {
      return wait(retryDelay).then(() => fetchWithRetry(input, init, retries - 1))
    }
  }
  return response
}
